type GetPriceText = (price: number) => string;

export const NUMBER_SEPARATOR_REG_EXP = /\B(?=(\d{3})+(?!\d))/g;

export const getPriceText: GetPriceText = price =>
	price ? `${price}`.replace(NUMBER_SEPARATOR_REG_EXP, ' ') : '';
